import Vue from 'vue';
import Router from 'vue-router';
import VueClipboard from 'vue-clipboard2';

require('../utils/extends');
Vue.use(Router);
Vue.use(VueClipboard);

Router.prototype.goBack = function() {
    this.isBack = true
    window.history.go(-1)
}

const routerPush = Router.prototype.push
const routerReplace = Router.prototype.replace
Router.prototype.push = function push(location) {
    return routerPush.call(this, location).catch(error => error)
}

Router.prototype.replace = function push(location) {
    return routerReplace.call(this, location).catch(error => error)
}

export default new Router({
    routes: [{
            path: '/',
            name: 'index',
            component: (resolve) => {
                require(['@/pages/package/index.vue'], resolve)
            },
            meta: {
                title: '套餐购买',
                deepth: 1
            }
        },
        {
            path: '/to-pay',
            name: 'pay',
            component: (resolve) => {
                require(['@/pages/package/to-pay.vue'], resolve)
            },
            meta: {
                title: '支付',
                deepth: 1
            }
        },
        {
            path: '/pay-result',
            name: 'payResult',
            component: (resolve) => {
                require(['@/pages/package/pay-result.vue'], resolve)
            },
            meta: {
                title: '支付结果',
                deepth: 1
            }
        },
        {
            path: '/pay-log',
            name: 'payLog',
            component: (resolve) => {
                require(['@/pages/package/pay-log.vue'], resolve)
            },
            meta: {
                title: '购买记录',
                deepth: 1
            }
        },
        {
            path: '/invoice',
            name: 'invoice',
            component: (resolve) => {
                require(['@/pages/package/invoice.vue'], resolve)
            },
            meta: {
                title: '可开票订单',
                deepth: 1
            }
        },
        {
            path: '/invoice-edit',
            name: 'invoiceEdit',
            component: (resolve) => {
                require(['@/pages/package/invoice-edit.vue'], resolve)
            },
            meta: {
                title: '开具发票',
                deepth: 1
            }
        },
        {
            path: '/invoice-log',
            name: 'invoiceLog',
            component: (resolve) => {
                require(['@/pages/package/invoice-log.vue'], resolve)
            },
            meta: {
                title: '开票历史',
                deepth: 1
            }
        },
        {
            path: '/invoice-header-detail',
            name: 'invoiceHeaderDetail',
            component: (resolve) => {
                require(['@/pages/package/invoice-header-detail.vue'], resolve)
            },
            meta: {
                title: '发票抬头详情',
                deepth: 1
            }
        },
        {
            path: '/invoice-header-log',
            name: 'invoiceHeaderLog',
            component: (resolve) => {
                require(['@/pages/package/invoice-header-log.vue'], resolve)
            },
            meta: {
                title: '发票抬头记录',
                deepth: 1
            }
        },
        {
            path: '/invoice-detail',
            name: 'invoiceDetail',
            component: (resolve) => {
                require(['@/pages/package/invoice-detail.vue'], resolve)
            },
            meta: {
                title: '开具发票',
                deepth: 1
            }
        }, {
            path: '/result',
            name: 'result',
            component: (resolve) => {
                require(['@/pages/package/result.vue'], resolve)
            },
            meta: {
                title: '开具结果',
                deepth: 1
            }
        }, {
            path: '/pay-html',
            name: 'pay-html',
            component: (resolve) => {
                require(['@/pages/package/payHtml.vue'], resolve)
            },
            meta: {
                title: '后台返回的支付html',
                deepth: 1
            }
        }, {
            path: '/hide-pay-cb',
            name: 'hide-pay-cb',
            component: (resolve) => {
                require(['@/pages/package/hide-pay-cb.vue'], resolve)
            },
            meta: {
                title: '取消支付回调',
                deepth: 1
            }
        }, {
            path: '/service-agreement',
            name: 'service-agreement',
            component: (resolve) => {
                require(['@/pages/package/service-agreement.vue'], resolve)
            },
            meta: {
                title: '服务协议',
                deepth: 1
            }
        },

    ],
});


// WEBPACK FOOTER //
// ./src/router/index.js